import createCounterInlineFabric from "../../../general/CoreHeader/components/CounterInline/counterInlineFabric";
import { createDisplayNameForHeaderSchevron } from "../../utils/createDisplayName";
import { createTestIdForHeaderSchevron } from "../../utils/createTestId";

const displayName = createDisplayNameForHeaderSchevron("CounterInline");
const testId = createTestIdForHeaderSchevron("counter-inline");

const HeaderSchevronCounterInline = createCounterInlineFabric(
    displayName,
    testId,
);

export default HeaderSchevronCounterInline;
